import { Box, ModalCloseButton } from '@chakra-ui/react';
import { InDesktop } from '@ui/components/MobileOrDesktop';
import {
  ModalOrDragDrawerContent,
  ModalOrDrawer,
  ModalOrDrawerHeader,
  ModalOrDrawerOverlay,
} from '@ui/components/ModalOrDrawer';
import {
  TransactionError,
  TransactionPending,
} from '@ui/components/TransactionDrawer';
import { useTranslations } from '@ui/i18n';
import { getGardenName } from '@ui/utils/garden';

import { DefaultContent } from './DefaultContent';
import { SuccessContent } from './SuccessContent';
import { useGardenHarvestDrawer } from './useGardenHarvestDrawer';
import { GARDEN_HARVEST_STEP } from './utils';

export const GardenHarvestDrawer = () => {
  const t = useTranslations();

  const isOpen = useGardenHarvestDrawer((s) => s.isOpen);
  const coinMode = useGardenHarvestDrawer((s) => s.coinMode);
  const step = useGardenHarvestDrawer((s) => s.step);
  const onClose = useGardenHarvestDrawer((s) => s.onClose);
  const error = useGardenHarvestDrawer((s) => s.error);
  const gardenType = useGardenHarvestDrawer((s) => s.gardenType);

  return (
    <ModalOrDrawer
      variant="wholeScreen"
      placement="bottom"
      scrollBehavior="inside"
      isOpen={isOpen}
      onClose={onClose}
      size={{
        base: 'full',
        desktop: 'md',
      }}
    >
      <ModalOrDrawerOverlay bg="bg-gauze" />
      <ModalOrDragDrawerContent>
        <InDesktop>
          <ModalCloseButton />
        </InDesktop>
        <ModalOrDrawerHeader>
          {t('Harvest')}
          <Box mt="3px" color="text-light" textStyle="caption">
            {getGardenName(coinMode, gardenType)}
          </Box>
        </ModalOrDrawerHeader>
        {step === GARDEN_HARVEST_STEP.default && <DefaultContent />}
        {step === GARDEN_HARVEST_STEP.confirming && (
          <TransactionPending.Content />
        )}
        {step === GARDEN_HARVEST_STEP.failed && (
          <TransactionError.Content error={error} mx="16px" />
        )}
        {step === GARDEN_HARVEST_STEP.success && <SuccessContent />}
      </ModalOrDragDrawerContent>
    </ModalOrDrawer>
  );
};
